import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Button from 'design-system/Button';
import { CardView, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import QuoteCardHeader from '../../QuoteCardHeader';
import QuoteTrustPilotLink from '../../QuoteTrustPilotLink';
import QuotePromotionBanner from './QuotePromotionBanner';
import QuoteCardValue from '../../QuoteCardValue';
const QuoteCard = ({ item, onPress, onInfoPressed }) => {
    const { data } = item;
    const { tariff } = data;
    if (!tariff)
        return null;
    const onPressRow = () => {
        onPress(item);
    };
    const onPressInfo = () => {
        onInfoPressed(item);
    };
    const renderBreakDown = () => {
        const { projection } = data;
        const { paymentValue, estimatedSaving } = projection;
        const { electricity, gas } = tariff;
        const gasexitfee = gas && gas.terminationFee ? gas.terminationFee : 0;
        const electricityexitfee = electricity && electricity.terminationFee
            ? electricity.terminationFee
            : 0;
        const exitfee = electricityexitfee + gasexitfee;
        const yearlyPaymentValue = paymentValue * 12;
        const monthlyEstimatedSavings = estimatedSaving / 12;
        return (<View style={styles.breakdownRow}>
        <QuoteCardValue reversed value={<Text TextThin-14 Gray-70>
              <Amount Numbers-16 value={{ value: paymentValue, currency: 'GBP' }} showFraction={false}/>{' '}
              / mo
              {'\n'}
              <Amount Numbers-16 value={{ value: yearlyPaymentValue, currency: 'GBP' }} showFraction={false}/>{' '}
              / yr
            </Text>} label="estimated Cost"/>
        <Spacer flex/>
        <QuoteCardValue reversed value={<Amount Numbers-16 value={{ value: exitfee, currency: 'GBP' }} showFraction={false}/>} label="early exit fee"/>
        <Spacer flex/>
        <QuoteCardValue reversed value={<Text TextThin-14 Gray-70>
              <Amount Numbers-16 value={{ value: monthlyEstimatedSavings, currency: 'GBP' }} showFraction={false}/>{' '}
              / mo
              {'\n'}
              <Amount Numbers-16 value={{ value: estimatedSaving, currency: 'GBP' }} showFraction={false}/>{' '}
              / yr
            </Text>} label="savings"/>
      </View>);
    };
    const renderSwitchButton = () => {
        const { onlineApplicationPermitted } = tariff;
        if (onlineApplicationPermitted) {
            return (<View style={styles.breakdownRow}>
          <Button hug square brandReversed flex onPress={onPressInfo} title="More details"/>
          <Spacer.W8 />
          <Button hug square brand flex onPress={onPressRow} title="Switch now"/>
        </View>);
        }
        return (<View style={styles.switchNotAvailable}>
        <Text Text-16 Gray-70>
          Switch not available
        </Text>
      </View>);
    };
    const { supplier } = data;
    const { name, rating } = supplier;
    if (!tariff)
        return null;
    return (<CardView noMarginTop>
      {tariff.promotion?.termsAndConditionsUrl !== undefined && (<QuotePromotionBanner promotion={tariff.promotion}/>)}
      <View style={styles.content}>
        <QuoteCardHeader title={name} subTitle={tariff.name} logoUrl={supplier.logoUrl}/>
        {rating?.reviews !== undefined && (<>
            <Spacer h={8}/>
            <QuoteTrustPilotLink rating={rating}/>
          </>)}
        <Spacer h={20}/>
        {renderBreakDown()}
        <Spacer h={32}/>
        {renderSwitchButton()}
      </View>
    </CardView>);
};
const styles = StyleSheet.create({
    content: {
        padding: rem(16),
    },
    switchNotAvailable: {
        alignItems: 'center',
    },
    breakdownRow: {
        flexDirection: 'row',
    },
});
export default memo(QuoteCard);
